import { ConfigurationForm } from 'src/components';

export const ConfigurationPage = () => {
    return <ConfigurationForm />;
};
